module.exports = __webpack_public_path__ + "img/1544899113.a0110f93.jpg";